import { config } from 'config';
import { toVfId } from 'commons/util/parse.js';
import { restAPIV2 } from './rest_api_v2';

const routes = {
    comment: (uuid) => `/comments/${toVfId(uuid)}`,
};

const getDefaultRestAPIV2 = (site_id) => restAPIV2.register(config.api_v2_url, site_id);

export const patchComment = (uuid, site_uuid, payload) => getDefaultRestAPIV2(toVfId(site_uuid)).patch(routes.comment(uuid), payload);
